export default {
    csManagement: {
        page: {
            title: 'CS Management',
            description: 'Manage tenant quotas, document limits and token consumption',
        },
        quota: {
            searchPlaceholder: 'Search tenant ID',
            typePlaceholder: 'Quota type',
            search: 'Search',
            create: 'Add Quota',
            tenantId: 'Tenant ID',
            quotaType: 'Quota Type',
            typeDocument: 'Document',
            typeToken: 'Token',
            quotaLimit: 'Limit',
            quotaUsed: 'Used',
            contractPeriod: 'Contract Period',
            contractStart: 'Start Date',
            contractEnd: 'End Date',
            status: 'Status',
            statusActive: 'Active',
            statusExpired: 'Expired',
            remark: 'Remark',
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            createTitle: 'Add Quota',
            editTitle: 'Edit Quota',
            cancel: 'Cancel',
            confirm: 'Confirm',
            saving: 'Saving...',
            featureConfig: 'Feature Config',
            featureConfigTitle: 'Feature Permission Config',
            featureDisclosure: 'Disclosure',
            featureDisclosureDesc: 'Patent disclosure drafting',
            featurePatentDraft: 'Patent Application',
            featurePatentDraftDesc: 'Patent application drafting',
            featureProsecution: 'OAR Response',
            featureProsecutionDesc: 'Office action response drafting',
            userQuotaTitle: 'User Quota Details',
            userQuotaHint: 'Company quota limit: {limit}',
            userEmail: 'User Email',
            unlimited: 'Unlimited',
            addUser: 'Add User',
            addUserPlaceholder: 'Enter user email',
            reset: 'Clear',
            tenantName: 'Company Name',
            configuredMembers: 'Configured Members',
            noConfiguredMembers: 'No configured members for this company',
            tenantInfoNotFound: 'Company not found',
            tenantInfoFailed: 'Failed to fetch, please retry',
            featureList: 'Features',
            featureAll: 'All',
        },
    },
}
